import React, { Component } from 'react';
import PageBanner from '../components/PageBanner';
import Footer from '../components/Footer';

export class Terms extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const existing = document.getElementById('termly-jssdk');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    document.body.appendChild(script);
  }

  render() {
    return (
      <div>
        <PageBanner title='Terms of Services' background='page-banner.jpg' />
        <div className='p-3'>
          <div
            name='termly-embed'
            data-id='e8c1da4f-33a2-4b3e-824e-2a7ecdccfb47'
          ></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Terms;
